<template>
  <v-container v-if="!userOnline">
    <v-row align="center">
      <v-col>
        <v-card text tile class="actual-state__single-image" white>
          <v-container fluid fill-height class="pa-0">
            <v-row
              no-gutters
              column
              class="text-center justify-space-between fill-height"
            >
              <template v-if="videos.src" class="text-center">
                <v-icon
                  v-if="isEditChecklist"
                  class="actual-state__icon-delete"
                  color="accent"
                  dense
                  size="16"
                  @click.prevent="deleteAndCleanVideo()"
                  >fas fa-plus</v-icon
                >
                <v-icon
                  v-else
                  class="actual-state__icon-download"
                  color="accent"
                  dense
                  size="16"
                  @click.prevent="downloadVideo(videos.src)"
                  >fas fa-download</v-icon
                >
                <video height="150" controls class="mauto-0">
                  <source :src="videos.src" id="video-prosic" />
                  Your browser does not support HTML5 video.
                </video>
                <v-col
                  tag="div"
                  block
                  class="text-center actual-state__image-text pa-0"
                  cols="12"
                  >{{ videos.titleSection }}</v-col
                >
              </template>
              <template v-else>
                <v-icon
                  v-if="isEditChecklist"
                  class="actual-state__icon"
                  color="gray"
                  @click.prevent="uploadImage()"
                  >fas fa-plus</v-icon
                >
                <v-icon v-else class="actual-state__icon" color="gray"
                  >visibility_off</v-icon
                >
                <template slot="loading">
                  <v-progress-circular
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </template>
                <v-col
                  tag="div"
                  block
                  class="text-center actual-state__image-text pa-0"
                  cols="12"
                >
                  {{ videos.titleSection }}
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <input
      :disabled="accessToEdit"
      v-show="false"
      ref="uploadVideo"
      type="file"
      accept="video/mp4,video/x-m4v,video/*"
      @change="updateFileVideo($refs.uploadVideo.files)"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentImageIndex: ""
    };
  },
  props: ["isEditChecklist", "accessToEdit"],
  computed: {
    ...mapState("checklist", ["videos"]),
    ...mapState("user", ["userOnline"])
  },
  methods: {
    uploadImage() {
      this.$refs.uploadVideo.click();
    },
    async updateFileVideo(refImage) {
      if (refImage) {
        let blobURL = URL.createObjectURL(refImage[0]);
        this.videos.src = blobURL;
        this.videos.file = refImage[0];
      }
    },
    deleteAndCleanVideo() {
      this.videos.src = null;
      this.videos.file = null;
    },
    downloadVideo(src) {
      window.open(src, "_blank");
    }
  }
};
</script>

<style>
.actual-state__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 170px;
  max-width: 200px;
  margin: 0 auto;
}
.actual-state__icon {
  padding: 60px;
  margin: 0 auto;
}
.actual-state__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
  z-index: 20;
}
.actual-state__icon-download {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  position: absolute;
  z-index: 20;
}
.actual-state__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
.mauto-0 {
  margin: 0 auto;
}
</style>
